export const GA_MEASUREMENT_ID = 'G-Z1ZFQLTJ09';

export function pageview(path) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });
}

export function event(action, params = {}) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', action, params);
}